<template>
  <div class="c-top-container">
    <div class="c-container-header">
      <template v-if="quality">
        <img src="~assets/images/high_quality.png" alt="" />
        <span>优质榜</span>
      </template>
      <template v-else-if="potential">
        <img src="~assets/images/observe.png" alt="" />
        <span>潜力榜</span>
      </template>
      <template v-else-if="danger">
        <img src="~assets/images/danger.png" alt="" />
        <span>危险榜</span>
      </template>
    </div>
    <div class="c-container-table">
      <Spin size="large" fix v-if="loading"></Spin>
      <div class="c-table-data">
        <el-table class="common-el-table-styles" height="100%" :data="data" border stripe>
          <template slot="empty" v-if="data.length">
            <span></span>
          </template>
          <template slot="empty" v-else>
            <img src="~assets/images/table-nodata.png" style="width: 100%" alt="" />
            <span>暂无数据</span>
          </template>
          <el-table-column prop="imageName" label="素材名称" :min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <a @click="showMedia(scope.row)" href="javascript:;"> {{ scope.row.imageName }} </a>
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="消耗" :min-width="80" sortable>
            <template slot-scope="scope">
              <span>{{ scope.row.amount | toThousands }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="newRoleRate" label="新创角ROI" :min-width="92" sortable>
            <template slot-scope="scope">
              <span>{{ scope.row.newRoleRate | toPercent }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="roi1" label="1日ROI" sortable>
            <template slot-scope="scope">
              <span>{{ scope.row.roi1 | toPercentFixed }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="roi3" label="3日ROI" sortable>
            <template slot-scope="scope">
              <span>{{ scope.row.roi3 | toPercentFixed }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="roi7" label="7日ROI" sortable>
            <template slot-scope="scope">
              <span>{{ scope.row.roi7 | toPercentFixed }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="planCount" width="80" label="计划数" sortable>
            <template slot-scope="scope">
              <span>{{ scope.row.planCount || '-' }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="c-load-more" v-if="moreLen">
          <span @click="$emit('on-more')">加载更多</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
export default {
  name: 'topContainer',
  props: {
    data: {
      type: Array
    },
    loading: {
      type: Boolean
    },
    quality: {
      type: Boolean
    },
    observe: {
      type: Boolean
    },
    potential: {
      type: Boolean
    },
    danger: {
      type: Boolean
    },
    more: {
      type: Boolean
    },
    pageSize: {
      type: Number
    }
  },
  computed: {
    moreLen() {
      return isArray(this.data) && this.more && this.data.length >= this.pageSize
    }
  },
  methods: {
    sortChange(column) {
      let orderName
      if (column.order === 'ascending') orderName = 'asc'
      else if (column.order === 'descending') orderName = 'desc'
      this.$emit('on-sort', { sort: column.prop, order: orderName })
    },
    showMedia(row) {
      const video = row && row.imageType === 2
      let param = { video, row }
      if (!video) param = Object.assign({}, param, { src: row.coverUrl })
      this.$emit('on-click', param)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-top-container {
  min-width: 720px;
  width: 33.33%;
  height: 100%;
  border-radius: 4px;
  padding: 0 15px;
  background-color: #fff;

  .c-container-header {
    line-height: 30px;
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    span {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.8);
      font-weight: 600;
    }

    img {
      width: 20px;
      height: 20px;
      display: inline-block;
      margin-right: 6px;
    }
  }

  .c-container-table {
    position: relative;
    height: calc(100% - 38px);

    .c-table-data {
      overflow: hidden;
      scrollbar-width: thin;
      -webkit-overflow-scrolling: touch;
      width: 100%;
      height: 100%;

      .c-load-more {
        padding: 12px 0;
        text-align: center;

        span {
          display: inline-block;
          width: 96px;
          line-height: 24px;
          background-color: #f2f2f2;
          border-radius: 4px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
